module.exports = __webpack_public_path__ + "img/6effb45.jpg";